import React, { useEffect, useState } from "react";

import { AddUpdate } from '../../../ApiMethods/ApiMethods';

const AstroTimeTable = () => {


  const [timeData, setTimeData] = useState([]);
  const [firstrowData, setFirstrowData] = useState([]);
  const astroId = sessionStorage.getItem("AstroLoginId") ? sessionStorage.getItem("AstroLoginId") : '';

  useEffect(() => {
    astroId && fetchAstroTimeSlotData(astroId);
  }, [astroId]);

  const fetchAstroTimeSlotData = async () => {

    const sevenDaysInMilliseconds = 7 * 24 * 60 * 60 * 1000;
    const dateSevenDaysAgo = new Date(Date.now() + sevenDaysInMilliseconds);
    const val = { FromDate: new Date(), ToDate: dateSevenDaysAgo, AstroId: "1", };
    try {
      const response = await AddUpdate("AstroTimeSlot/GetData_AstroTimeSlot", val);
      if (response) {
        setTimeData(response.slice(1));
        setFirstrowData(response[0]);
      }
    } catch (error) {
      console.error("Error fetching time slot data:", error);
    }
  };

  const updateTimeSlot = async (date, columnName, columnValue, IsLeave) => {
    const val = { Date: date, ColumnName: columnName, ColumnValue: columnValue, AstroID: astroId, IsLeave: IsLeave };
    try {
      const response = await AddUpdate("AstroTimeSlot/Update_AstroTimeSlot", val);
      
      if (response) {
        fetchAstroTimeSlotData(astroId);
      }
    } catch (error) {
      console.error("Error updating time slot:", error);
    }
  };

  

  const handleCellClick = (rowIndex, columnName) => {
    const updatedRow = timeData[rowIndex];
    if (columnName === "IsLeave") {
      const newStatus = updatedRow[columnName] === "1" ? "No" : "Yes";
      const IsLeaveValue = newStatus === "Yes" ? 1 : 0;
      updateTimeSlot(updatedRow?.Date, columnName, newStatus, IsLeaveValue);

      if (newStatus === "Yes") {
        Object.keys(updatedRow)
          .filter((key) => key.startsWith("c")) // Only update columns like c1, c2, ...
          .forEach((slotKey) => {
            if (updatedRow[slotKey] !== "Offline") {
              // updateTimeSlot(updatedRow?.Date, slotKey, "Offline", 0);
              updateTimeSlot(updatedRow?.Date, slotKey, "Offline", IsLeaveValue);
            }
          });
      }
    } else {
      const newStatus = updatedRow[columnName] === "Available" ? "Offline" : "Available";
      updateTimeSlot(updatedRow?.Date, columnName, newStatus, 0);
    }
  };



  



  return (


    <div>
      <h2 class="text-center py-4 text-xl font-semibold">Edit Time Table</h2>
      <div class="flex flex-col md:flex-row">
        <div class="w-full">

          <div class="overflow-auto h-[80vh]">
            <table class="min-w-full border-separate border-spacing-0 border-gray-300">
              <thead>
                <tr>
                  <th class="border border-gray-300 px-10 py-2 font-[700] text-center">Day Name</th>
                  <th class="border border-gray-300 px-10 py-2 font-[700] text-center">Date</th>
                  <th class="border border-gray-300 px-10 py-2 font-[700] text-center">On Leave?</th>
                  {Object.keys(firstrowData || {})
                    .filter((key) => key.startsWith("c"))
                    .map((key, index) => (
                      <th key={index} className="border border-gray-300 px-10 font-[700] py-2 text-center">
                        {firstrowData[key]}
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {timeData?.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td class="border border-gray-300 px-10 font-[700] py-2 text-center">{row?.DayName}</td>
                    <td class="border border-gray-300 px-10 py-2 font-[700] text-center">{row?.Date}</td>
                    <td
                      onClick={() => { handleCellClick(rowIndex, "IsLeave"); fetchAstroTimeSlotData() }}
                      className={`border border-gray-500 px-10 py-6  cursor-pointer text-center 
                      ${row?.IsLeave === "1" || row?.IsLeave === 1 ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}`}
                    >
                      {row?.IsLeave === "1" || row?.IsLeave === 1 ? "Yes" : "No"}
                    </td>
                    {Array.from({ length: 48 }, (_, colIndex) => {
                      const columnName = `c${colIndex + 1}`;
                      const cellValue = row[columnName];
                      return (
                        <td
                          key={colIndex}
                          onClick={() => row?.IsLeave !== "Yes" && handleCellClick(rowIndex, columnName)}
                          className={`border border-gray-500 px-10 py-6 cursor-pointer  text-center 
                        ${row?.IsLeave === '1' || row?.IsLeave === 1 ? "bg-gray-100 text-gray-400 pointer-events-none" : cellValue === "Available" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}`}
                        >
                          {cellValue}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>



  );
};

export default AstroTimeTable;


